//import axios from 'axios'
import axios from './axiosConfig'

export default {

	async returnDevicesTest(body){
		return axios.post('get/unit/test', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnDevices(body){
		return axios.post('get/unit/devices', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnRoomDevices(body){
		return axios.post('get/room/devices', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnEquipments(body){
		return axios.post('get/equipment', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnUserArticle(body){
		return axios.post('get/user/articles', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	
	
	
	
	async returnDevicesEquipment(body){
		return axios.post('api/material/devices/equipment', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	
	async returnSupplyAirValves(body){
		return axios.post('api/material/valves/supply', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnExhaustAirValves(body){
		return axios.post('api/material/valves/exhaust', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnInflowElement(body){
		return axios.post('api/material/inflow', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnDistributionBox(body){
		return axios.post('api/material/distribution', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnPipes(body){
		return axios.post('api/material/pipes', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnSilencer(body){
		return axios.post('api/material/silencer', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnEquipment(body){
		return axios.post('api/material/equipment', body)
	    	.then(response => {
	  			return response.data;
		});
	},
	async returnIsopipe(body){
		return axios.post('api/material/isopipe', body)
	    	.then(response => {
	  			return response.data;
		});
	},	
	async returnLewt(body){
		return axios.post('api/material/lewt', body)
	    	.then(response => {
	  			return response.data;
		});
	},	
	async returnSewt(body){
		return axios.post('api/material/sewt', body)
	    	.then(response => {
	  			return response.data;
		});
	},	
}